import { createApp, createSSRApp, h, nextTick, watch } from 'vue';
import LoadingScreen from '@ui/components/loading/LoadingScreen.vue';
import {
	bootstrapFailed,
	initialLoadFailed,
	initialLoadingSkipped,
	initialLoadingFinished,
	initialViewReady,
} from '@common/loading/initialLoading';
import messages from '@common/locales/en.json';

const container = document.getElementById('startup-loading')!;
const startedAt = Number(container.dataset.startedAt ?? performance.now());
const appRoot = document.getElementById('app')!;
initialLoadingSkipped.value = container.dataset.enabled !== 'true';
appRoot.inert = !initialLoadingSkipped.value;
// Hydrate the early HTML so its compositor animations keep their original timeline.
const mountStartup = initialLoadingSkipped.value ? createApp : createSSRApp;
let finished = false;
const startup = mountStartup({
	render() {
		if (bootstrapFailed.value) {
			return h('div', { class: 'loading-screen', role: 'alert' }, [
				h('div', { style: 'text-align:center;color:var(--loading-icon)' }, [
					h('p', messages.common.loadFailed),
					h(
						'button',
						{ type: 'button', onclick: () => window.location.reload() },
						messages.common.retry,
					),
				]),
			]);
		}
		if (initialLoadingSkipped.value) return null;
		return h(LoadingScreen, {
			label: messages.common.loading,
			startedAt,
			ready: initialViewReady.value,
			skipCycle: initialLoadFailed.value,
			onComplete: finish,
		});
	},
});
async function finish() {
	await nextTick();
	requestAnimationFrame(() => {
		if (!initialViewReady.value || bootstrapFailed.value || finished) return;
		finished = true;
		initialLoadingFinished.value = true;
		appRoot.inert = false;
		stopSkippedView();
		startup.unmount();
		container.remove();
	});
}
const stopSkippedView = watch([initialLoadingSkipped, initialViewReady], ([skipped, ready]) => {
	if (!skipped) return;
	appRoot.inert = false;
	if (ready) void finish();
});
startup.mount(container);
container.style.removeProperty('display');
void import('./Standalone').catch(() => {
	bootstrapFailed.value = true;
});
